export default __webpack_public_path__ + "static/media/service_2.0e7f14fa.png";